import React, { useState, useEffect } from 'react';
import {  Row, Col, Card,  CardTitle, CardBody } from 'reactstrap';
import document from '../../assets/images/document.png';
import profit from '../../assets/images/profit.png';
import user from '../../assets/images/user.png';
import customer from '../../assets/images/customer.png';
import request from '../../assets/images/request.png';

import { AGENCY_DASHBOARD_URL } from '../../utils/APIEndpoints';
import { authHeader } from '../../utils/functions/CoreFunctions';
import API from '../../redux/actions/API';
import { getCurrentAgencyId, getAlertToast } from '../../utils/functions/CustomFunctions';
import { USERS_ROUTE_PATH, CUSTOMERS_ROUTE_PATH, DOCUMENTS_PATH, REQUESTS_PATH } from '../../utils/AppRoutes';
import { Link } from 'react-router-dom';
import MonthlyServiceRequests from './charts/MonthlyServiceRequests';
import MonthlyServicePayments from './charts/MonthlyServicePayments';
import CustomLoader from '../common/CustomLoader';
import Swal from 'sweetalert2';

const Dashboard = (props) => {

   //State
   const [dashboardData,setDashboardData]  = useState({});
   const [loading,setLoading] = useState(false);
 
   //Get Dashboard Data
   const getDashboardData = async () => {
    let queryData = { agencyId: parseInt(getCurrentAgencyId()) };
     try{
       setLoading(true);
       const options = {
           method : 'GET',
           url : AGENCY_DASHBOARD_URL,
           headers: authHeader(),
           params : queryData
       };
       const response = await API(options);
       const {status} = response.data;
       if(status === 'Success')
       {  
           setDashboardData(response.data);
       }
       }catch(error){
           if (error.response) {
           let { data } = error.response;
           Swal.fire(getAlertToast('error', data.message));
           }
       }finally{
           setLoading(false);
       }
   }
 
    //Did Mount
    useEffect(() => {
      getDashboardData();
    }, []);  

    const {
      customerCount = 0,
      totalAgencyUser = [],
      totalRequest = [],
      totalPayment = 0,
      monthlyReport = [],
      totalServiceRequest = 0
    } = dashboardData;

    let totalUsers = 0,adminsCount = 0,managersCount = 0;
    if(totalAgencyUser.length)
    {
      totalUsers = totalAgencyUser.find(element => element.roleBasedCount === 'totalAgencyUser').count;
      adminsCount = totalAgencyUser.find(element => element.roleBasedCount === 'merchantAdmin').count;
      managersCount = totalAgencyUser.find(element => element.roleBasedCount === 'merchantManager').count;
    }

    let totalRequests = 0,acceptedCount = 0,pendingCount = 0,rejectedCount = 0 ;
    if(totalRequest.length)
    {
      totalRequests = totalRequest.find(element => element.serviceStatus === 'totalRequest').count;
      acceptedCount = totalRequest.find(element => element.serviceStatus === 'Accepted').count;
      pendingCount = totalRequest.find(element => element.serviceStatus === 'Pending').count;
      rejectedCount = totalRequest.find(element => element.serviceStatus === 'Rejected').count;
    }

    return (       
      <div>
        <Row className="mt-4">
          <Col xs="4" className="dash-active">
            <Link to={USERS_ROUTE_PATH} className="link">
              <Card body>
                <img src={user} className="dashImg" alt="Users" />
                <CardTitle className="dashboard-title">Users</CardTitle>
                <h3 className="mb-2 mt-2 dashboard-value">{totalUsers}</h3>
              </Card>

              <Card body className="dash-hover">
              <div>
                <p>Admins : {adminsCount}</p>
                <p>Managers : {managersCount}</p>  
                </div> 
              </Card>

            </Link>



         

          </Col>
          <Col xs="4">
          <Link to={CUSTOMERS_ROUTE_PATH} className="link">
            <Card body>
            <img src={customer} className="dashImg" alt="Customers" />
            <CardTitle className="dashboard-title">Total Customers</CardTitle>
            <h3 className="mb-2 mt-2 dashboard-value">{customerCount}</h3>
            </Card>
          </Link>
          </Col>
          <Col xs="4" className="dash-active">
            <Link to={DOCUMENTS_PATH} className="link">
              <Card body>
              <img src={document} className="dashImg" alt="Documents" />
              <CardTitle className="dashboard-title">Documents</CardTitle>
              <h3 className="mb-2 mt-2 dashboard-value">{totalRequests}</h3>
           
              </Card>
              <Card body className="dash-hover">
                <div>
              <p>Accepted : {acceptedCount}</p>
              <p>Rejected : {rejectedCount}</p>
              <p>Waiting for approval : {pendingCount}</p>
              </div>
              </Card>
            </Link>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col xs="4">
            <Link to={ REQUESTS_PATH} className="link">
              <Card body>
              <img src={request} className="dashImg" alt="Requests" />
              <CardTitle className="dashboard-title">Total Service Requests</CardTitle>
              <h3 className="mb-2 mt-2 dashboard-value">{totalServiceRequest}</h3>
              </Card>
            </Link>
          </Col>        
          <Col xs="4">
            <Card body>
            <img src={profit} className="dashImg" alt="Profit" />
            <CardTitle className="dashboard-title">Total Payments</CardTitle>
            <h3 className="mb-2 mt-2 dashboard-value">${parseFloat(totalPayment).toFixed(2)}</h3>
            </Card>
          </Col>
        </Row>

        <Row>
          <Col md="6">
            <Card body className="mt-4">
              <CardTitle className="mb-4 tableTitleBg">Monthly Service Requests</CardTitle>
              <CardBody>
                {loading ? 
                  <center><CustomLoader loading={loading}/></center>
                  :
                  <MonthlyServiceRequests data={monthlyReport}/>
                }
              </CardBody>
            </Card>
          </Col>
          <Col md="6">
            <Card body className="mt-4">
              <CardTitle className="mb-4 tableTitleBg">Monthly Service Payments</CardTitle>
              <CardBody>
              {loading ? 
                  <center><CustomLoader loading={loading}/></center>
                  :
                <MonthlyServicePayments data={monthlyReport}/>
              }
              </CardBody>
            </Card>
          </Col>      
        </Row>

        </div>
    );
}

export default Dashboard;
